<template>
  <v-card
    max-width="100%"
    class="mx-auto"
  >
    <v-toolbar
      color="indigo"
      dark
    >
      <v-spacer />
      <v-toolbar-title>- DOCUMENTOS -</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-list>
      <v-list-tile>
        <v-list-tile-icon>
          <v-icon>folder</v-icon>
        </v-list-tile-icon>
        Declaración jurada de aceptación de nuevos procedimientos de admisión
        <v-spacer />
        <v-btn
          disabled
          color="blue-grey"
          class="ma-2 white--text"
          href="http://admisionapi.uniq.edu.pe/storage/app/public/DocumentosAdmisión/DECLARACION%20JURADA%20DE%20RATIFICACION%20-%20ACEPTACION%20NUEVOS%20PROCEDIMIENTOS.pdf"
        >
          Descargar
          <v-icon
            right
            dark
          >
            cloud_download
          </v-icon>
        </v-btn>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-icon>
          <v-icon>folder</v-icon>
        </v-list-tile-icon>
        Declaracion jurada de no tener antecedes penales ni judiciales -
        Traslado Externo Extraordinario
        <v-spacer />
        <v-btn
          disabled
          color="blue-grey"
          class="ma-2 white--text"
          href="http://test1.uniq.edu.pe/public/storage/documentos/declaracion%20jurada%20de%20no%20tener%20antecedentes%20penales%20ni%20judiciales.pdf"
        >
          Descargar
          <v-icon
            right
            dark
          >
            cloud_download
          </v-icon>
        </v-btn>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-icon>
          <v-icon>folder</v-icon>
        </v-list-tile-icon>
        Formato de compromiso - Traslado Externo Extraordinario
        <v-spacer />
        <v-btn
          disabled
          color="blue-grey"
          class="ma-2 white--text"
          href="http://test1.uniq.edu.pe/public/storage/documentos/Formato%20de%20Compromiso%20-%20Traslado%20Externo%20Extraordinario.pdf"
        >
          Descargar
          <v-icon
            right
            dark
          >
            cloud_download
          </v-icon>
        </v-btn>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-icon>
          <v-icon>folder</v-icon>
        </v-list-tile-icon>
        Tabla de equivalencias de Carreras - Traslado Externo Extraordinario
        <v-spacer />
        <v-btn
          disabled
          color="blue-grey"
          class="ma-2 white--text"
          href="http://test1.uniq.edu.pe/public/storage/documentos/CARRERAS%20AFINES.pdf"
        >
          Descargar
          <v-icon
            right
            dark
          >
            cloud_download
          </v-icon>
        </v-btn>
      </v-list-tile>
      <v-divider />
      <v-list-tile>
        <v-list-tile-icon>
          <v-icon>folder</v-icon>
        </v-list-tile-icon>
        Formato 01: Carta de compromiso para representar de manera exclusiva a
        la UNIQ en la disciplina deportiva acreditada.
        <v-spacer />
        <v-btn
          color="blue-grey"
          class="ma-2 white--text"
          href="http://admisionapi.uniq.edu.pe/public/storage/DocumentosAdmisi%C3%B3n/Carta%20de%20compromiso%20para%20Deportista%20Calificado.pdf"
        >
          Descargar
          <v-icon
            right
            dark
          >
            cloud_download
          </v-icon>
        </v-btn>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-icon>
          <v-icon>folder</v-icon>
        </v-list-tile-icon>
        Formato 02: Certificado de pertenencia de una comunidad Andino
        Amazonico.
        <v-spacer />
        <v-btn
          color="blue-grey"
          class="ma-2 white--text"
          href="http://admisionapi.uniq.edu.pe/public/storage/DocumentosAdmisi%C3%B3n/Acreditaci%C3%B3n%20de%20Comunidad%20Andina-Amaz%C3%B3nica.pdf"
        >
          Descargar
          <v-icon
            right
            dark
          >
            cloud_download
          </v-icon>
        </v-btn>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-icon>
          <v-icon>folder</v-icon>
        </v-list-tile-icon>
        Formato 03: Carta de compromiso del postulante para laborar en su
        comunidad de origen por lo menos un año a la culminacion de sus estudios
        en la UNIQ.
        <v-spacer />
        <v-btn
          color="blue-grey"
          class="ma-2 white--text"
          href="http://admisionapi.uniq.edu.pe/public/storage/DocumentosAdmisi%C3%B3n/Carta%20de%20compromiso%20de%20postulante%20modalidad%20Andina%20Amazonica.pdf"
        >
          Descargar
          <v-icon
            right
            dark
          >
            cloud_download
          </v-icon>
        </v-btn>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-icon>
          <v-icon>folder</v-icon>
        </v-list-tile-icon>
        Declaración jurada de culminación de educación secundaria
        <v-spacer />
        <v-btn
          disabled
          color="blue-grey"
          class="ma-2 white--text"
          href="http://admisionapi.uniq.edu.pe/public/storage/DocumentosAdmisi%C3%B3n/Declaraci%C3%B3n%20jurada%20de%20culminaci%C3%B3n%20de%20educaci%C3%B3n%20secundaria.pdf"
        >
          Descargar
          <v-icon
            right
            dark
          >
            cloud_download
          </v-icon>
        </v-btn>
      </v-list-tile>
    </v-list>
  </v-card>
</template>
<script>
export default {
  data: () => ({})
}
</script>
